// Subtle synthesized "ding" using Web Audio API. Zero-asset, one-time cost.
// Browsers throttle background audio but allow it as long as the tab has had
// a prior user gesture (login covers that).

const MUTE_KEY = "pp:notif:muted";

let ctxRef = null;
function getCtx() {
  if (typeof window === "undefined") return null;
  if (ctxRef && ctxRef.state !== "closed") return ctxRef;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try {
    ctxRef = new AC();
  } catch {
    ctxRef = null;
  }
  return ctxRef;
}

/**
 * Play a two-note descending chime (~500ms). Silent if muted.
 * Fails silently if AudioContext isn't available or is blocked.
 */
export function playChime() {
  if (isMuted()) return;
  const ctx = getCtx();
  if (!ctx) return;
  // Resume if suspended (Chrome/Safari autoplay policy)
  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
  try {
    const now = ctx.currentTime;
    // Two-note descending motif: E5 → C5 (subtle, pleasant)
    playNote(ctx, 659.25, now, 0.22);
    playNote(ctx, 523.25, now + 0.18, 0.28);
  } catch {
    /* audio errors shouldn't crash the app */
  }
}

function playNote(ctx, freq, startAt, duration) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;

  // Envelope: quick attack, gentle decay — keeps it "subtle"
  const peak = 0.08; // low volume so it isn't jarring
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(peak, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.02);
}

export function isMuted() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setMuted(next) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(MUTE_KEY, next ? "1" : "0");
  } catch {
    /* ignore */
  }
}
